














import { createComponent, computed, ref } from "@vue/composition-api";
import BaseNumericKeyOnlyInput from "./BaseNumericKeyOnlyInput.vue";
/* eslint-disable */
import { NumericFieldProps } from "@web-components/types/NumericFieldProps";
import { ValidationMessage } from "@web-components/types/ValidationMessage";
/* eslint-enable */
export default createComponent({
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    value: {
      type: [Number, String],
      required: false
    }
  },
  components: {
    BaseNumericKeyOnlyInput
  },
  setup(props: Readonly<NumericFieldProps>, { emit }) {
    const isValid = ref(false);
    const localValue = computed({
      get: () => {
        return props.value;
      },
      set: val => {
        emit("input", val);
      }
    });

    const handleValidation = (input: ValidationMessage) => {
      emit("validation", input);
      isValid.value = input.valid;
    };

    return {
      localValue,
      handleValidation,
      isValid
    };
  }
});
